import React from 'react';
import { Avatar, Text } from 'src/@vymo/ui/atoms';
import { getIcon } from '../../queries';
import styles from '../../index.module.scss';

function RankingList({ title, rankings }: any) {
  return (
    <div className={styles.dashboardRankings}>
      <div className={styles.dashboardRankings__header}>
        <Text semiBold>{title}</Text>
      </div>
      {rankings.map((item, idx) => (
        <div className={styles.dashboardRankings__ranks}>
          {getIcon(idx)}
          <Avatar text={item?.name?.charAt(0)} size="small" />

          <div className={styles.dashboardRankings__ranks__info}>
            <Text>{item.name}</Text>
            <Text type="subText">{item.description}</Text>
          </div>

          <Text semiBold>{item.points}</Text>
        </div>
      ))}
    </div>
  );
}

export default RankingList;
